import styled, { css } from "styled-components";
import { fontQuicksand } from "../../common/mixins/mixin"
import { white, royal, lightBlue } from '../../../../app/js/components/loggedout/shared-styles/Colors';
import { device, breakpoints } from '../../../../app/js/utils/responsive_utilities';
import { assetPath } from '../../../../app/js/utils/web-helper';

export const GradeBox = styled.div`
  display: flex;
  justify-content: space-around;
  flex-wrap: wrap;
  padding: 1rem;
  max-width: 32rem;
  margin: 0 auto;
  @media (max-width: ${breakpoints.xl - 1}px) {
    padding-top: 6rem;
  }
  @media ${device.PhoneTabletLandscape}{
    padding-top: 2rem;
  }
  @media (min-width: ${breakpoints.xl}px) {
    max-width: 90%;
  }
`


export const GradeItem = styled.div`
  position: relative;
  width: 6rem;
  height: 6rem;
  margin: .3rem;
  cursor: pointer;
  img{
    width: 100%;
    height: 100%;
    ${(props) => props.rotate ? css`transform : rotate(${props.rotate}deg)` : ``}
  }

  &:hover {
    &:before {
      content: '';
      position: absolute;
      width: 100%;
      height: 100%;
      background: url(${props => props.hoverImage ? assetPath(props.hoverImage) : ''}) center/contain no-repeat;
      ${(props) => props.rotate ? css`transform : rotate(${props.rotate}deg)` : ``}
    }
    img {
      display: none;
    }
  }

  @media ${device.Desktop}{
    width: 11.8rem;
    height: 11.8rem;
    margin: .3rem;
  }

  &:nth-child(1){
    .grade-label{
      ${props => {
    return props.isUkorAu ? `
          font-size: 12px;
          line-height: 14px;
          ` : ""
  }}
      @media ${device.Desktop}{
        ${props => {
    return props.isUkorAu ? `
            font-size: 20px;
            line-height: 24px;  
        ` : ""
  }}
      }
    }
  }
`

export const GradeLabel = styled.p`
  position:absolute;
  font-family: Graphie;
  font-style: normal;
  ${fontQuicksand(1.8, 2.2, 7)}
  text-align: center;
  color: ${royal};
  top:50%;
  left:50%;
  transform: translate(-50%,-50%);
  margin: 0;
  width: 100%;
  @media ${device.Desktop}{
    font-size : 3.2rem;
  }
`

export const ModalFooter = styled.div`
  margin: 1rem auto;
  width: 80%;
  @media ${device.Desktop}{
    margin: 5rem auto 0;
  }
`

export const FooterText = styled.p`
  ${fontQuicksand(1.2, 1.6, 7)}
  text-align: center;
  color: ${white};
  @media ${device.Desktop}{
    ${fontQuicksand(1.6, 2, 7)}
  }
`